// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vI1h","name":"Header_name__3PphE","birthday":"Header_birthday__24g9n","skeleton":"Header_skeleton__1G_PN"};